import { type QueueIncidentErrorConfig } from '@collector/desktop-feature-incidents-queue-core'
import { createNullableProvideInject } from '@collector/shared-ui'

export const [provideQueueIncidentErrorConfig, injectQueueIncidentErrorConfig] =
  createNullableProvideInject<QueueIncidentErrorConfig>(
    'queueIncidentErrorConfig',
  )
